<template>
  <div class="card chart-card">
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <div id="chart-container" class="chart-container">
        <svg id="chart" v-if="!obtaining_graph_counts"></svg>
        <circular-loader v-if="obtaining_graph_counts" />
      </div>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  // import Card from './Card.vue'
  import CircularLoader from '@/components/UIComponents/Buttons/CircularLoader.vue'
  import { drawSVG } from '@/d3/analytics/chart'

  export default {
    name: 'chart-card',
    components: {
      CircularLoader
    },
    props: {
    },
    data () {
      return {
        chartId: 'no-id',
        chart: null,
        obtaining_graph_counts: false,
      }
    },
    methods: {
      drawSVG,
      updateChartId () {
        const currentTime = new Date().getTime().toString()
        const randomInt = this.getRandomInt(0, currentTime)
        this.chartId = `div_${randomInt}`
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
      },
      async obtainGraphCountsIfNecessary () {
        if (!this.hasGraphData) {
          this.obtaining_graph_counts = true;
          await this.$store.dispatch('obtainGraphCounts')
          this.obtaining_graph_counts = false;
        }
      },
      handleResize () {
        this.drawSVG()
      },
    },
    computed: {
      hasGraphData () {
        return this.$store.getters.graphData.counts != undefined
      },
      timePeriod () {
        return this.$store.getters.timePeriod
      },
      countType () {
        return this.$store.getters.countType
      },
    },
    watch: {
      async timePeriod () {
        await this.obtainGraphCountsIfNecessary()
        this.drawSVG()
      },
      async countType () {
        await this.obtainGraphCountsIfNecessary()
        this.drawSVG()
      },
    },
    async mounted () {
      await this.obtainGraphCountsIfNecessary()
      this.drawSVG()
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>
<style>

</style>
